import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import cogoToast from "cogo-toast";
import { BACKEND_URL } from "../../../constants";
import Input from "components/Input/Input";
import PublitioAPI from 'publitio_js_sdk'
import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import Datetime from 'react-datetime';
import 'moment/locale/pl';
import { 
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  EditorProvider,
  Editor,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
  Toolbar,
} from 'react-simple-wysiwyg';
import ClipLoader from "react-spinners/ClipLoader";
import "react-datetime/css/react-datetime.css";
import Layout from "../layout";

function ensurePublitioTransform(url, defaultTransform = "h_720") {
  try {
    const parsed = new URL(url);

    // Sprawdzamy czy link jest z Publitio
    if (!parsed.hostname.includes("publit.io")) return url;

    const pathParts = parsed.pathname.split("/").filter(Boolean);
    const fileIndex = pathParts.indexOf("file");

    // Jeżeli po "file" jest transformacja → zostaw
    if (
      fileIndex >= 0 &&
      pathParts[fileIndex + 1] &&
      pathParts[fileIndex + 1].match(/^[a-z]_\d+/)
    ) {
      return url;
    }

    // Dodaj domyślną transformację
    pathParts.splice(fileIndex + 1, 0, defaultTransform);
    parsed.pathname = "/" + pathParts.join("/");

    return parsed.toString();
  } catch (e) {
    console.error("Błędny URL Publitio:", e);
    return url;
  }
}

const PageAddArticles = () => {
  const publitio = new PublitioAPI('m7RBc51bBSJtDLyfn5ox', 'D7e4hWupPLHs0wqpXQDNQy2kJ6vVQZWZ')
  const navigate = useNavigate()
  const [categories,setCategories] = useState([])
  const [sponsor, setSponsor] = useState(0)
  const [status, setStatus] = useState(1)
  const [sections,setSections] = useState([])
  const [subcategories,setSubCategories] = useState([])
  const [categoryid, setCategoryId] = useState(0)
  const [type, setType] = useState("image")
  const [longDescription, setLongDescription] = useState('');
  const [secondDescription, setSecondDescription] = useState('')
  const [sectionid, setSectionId] = useState(9)
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(false)
  const [subcategoryid, setSubCategoryId] = useState(0)
  const [date,setDate] = useState("")
  let user = sessionStorage.getItem("user")
  let userId = JSON.parse(user)?.user.id
  const initialized = useRef(false);
  const fileInputRef = useRef(null);
  const {
    register,
    getValues,
    // formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      title: "",
      description:"",
      // long_description:"",
      image: "",
      video:""
    },
  });

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetch(`${BACKEND_URL}/categories`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.hasOwnProperty("error")) {
           setCategories(response)
          }
        })
        .catch((error) => {
          console.error("error: ", error);
        })
        .finally(() => {
          console.log("finally")
        })
    }
  }, [JSON.parse(user)?.user.id, user]);



  useEffect(() => {
    // if (!initialized.current) {
    //   initialized.current = true;
      fetch(`${BACKEND_URL}/subcategories`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.hasOwnProperty("error")) {
           setSubCategories(response.result)
          }
        })
        .catch((error) => {
          console.error("error: ", error);
        })
        .finally(() => {
          console.log("finally")
        })
  }, []);


  useEffect(() => {
    // if (!initialized.current) {
    //   initialized.current = true;
      fetch(`${BACKEND_URL}/sections`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.hasOwnProperty("error")) {
           setSections(response)
          }
        })
        .catch((error) => {
          console.error("error: ", error);
        })
        .finally(() => {
          console.log("finally")
        })
  }, []);


  const onChangeDate = (eventDate) => {
    setDate(eventDate)
  }

  const resetDate = () => {
    setDate(new Date())
    // setDate("")
  }


  const onChange = (e) => {
    if(e.target.name === "kategorie"){
      setCategoryId(e.target[e.target.selectedIndex].id)
    } 
    else if(e.target.name == "sekcje"){
      setSectionId(e.target[e.target.selectedIndex].id)
    }
    else if(e.target.name == "status"){
      setStatus(e.target[e.target.selectedIndex].value)
    }
    else if(e.target.name == "type"){
      setType(e.target[e.target.selectedIndex].value)
    }
    else if(e.target.name == "sponsor"){
      setSponsor(e.target[e.target.selectedIndex].value)
    }
    else{
      setSubCategoryId(e.target[e.target.selectedIndex].id)
    }
  }

const handleEditorImageUpload = async (e, setDescription) => {
  try {
    const file = e.target.files?.[0];
    if (!file) return;

    cogoToast.info("Wysyłanie zdjęcia...");

    const uploaded = await publitio.uploadFile(file, "file");
    const imageUrl = uploaded.url_preview;

    if (!imageUrl) {
      cogoToast.error("Nie udało się dodać zdjęcia");
      return;
    }

    const imageHtml = `
      <figure style="margin:20px 0;">
        <img
          src="${imageUrl}"
          alt=""
          loading="lazy"
          style="width:40%;max-width:100%;height:auto;display:block;"
        />
      </figure>
    `;

    document.execCommand("insertHTML", false, imageHtml);

    setTimeout(() => {
      const editors = document.querySelectorAll(".rsw-ce");
      const editor = editors[setDescription === setLongDescription ? 0 : 1];

      if (editor) {
        setDescription(editor.innerHTML);
      }
    }, 100);

    cogoToast.success("Zdjęcie dodane");
  } catch (err) {
    console.error(err);
    cogoToast.error("Błąd podczas uploadu zdjęcia");
  } finally {
    e.target.value = "";
  }
};

  const addArticles = async (e) => {
    setLoading(true)
    const data = getValues();
    let photo;
    let video;
    e.preventDefault();

    
photo = data.image?.[0]
  ? await publitio.uploadFile(data.image[0], "file")
  : null;

if (data.video?.[0]) {
  video = await publitio.uploadFile(data.video[0], "file");
}

// Wysyłanie wszystkich zdjęć galerii
const uploadedGallery = await Promise.all(
  galleryImages.map((file) =>
    publitio.uploadFile(file, "file")
  )
);

const galleryUrls = uploadedGallery
  .map((item) => item.url_preview)
  .filter(Boolean);

    if(video !== undefined){
      cogoToast.info("Film został dodany do hostingu. Zaczynam dodawać artykuł")
    }
    setTimeout(() => {
      fetch(`${BACKEND_URL}/add-articles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          title: data.title,
          date: date?.toDate ? date.toDate() : new Date(),
          status: status,
          description:data.description,
          category_id: categoryid,
          subcategory_id: categoryid === 7 ? 2: subcategoryid,
          section_id: sectionid,
          long_description: longDescription,
          second_description: secondDescription || null,
          type: type,
          sponsor:sponsor,
          image: photo?.url_preview || null,
          gallery_images: galleryUrls,
          video: video === undefined ? null : ensurePublitioTransform(video.url_stream, "h_480"),
          userId: userId == null ? 16: userId
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.statusCode === 200) {
            setLoading(false)
            cogoToast.success("Artykuł został dodany");
            window.location.reload()
          }
          else if(response.statusCode === 400) {
            cogoToast.error("Wystąpił jakiś błąd");
          } 
        })
        .catch((error) => console.error("error: ", error));
    }, 2000);
  };
  return (
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20 ">
        <Heading2>Dodaj Artykuł</Heading2>
        {/* <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
         Witamy
        </span> */}
      </header>

      <div className="max-w-md mx-auto space-y-6">
        {/* FORM */}
        <form className="grid grid-cols-1 gap-6" action="#" method="post">
          <label className="block">
            <Input
             {...register("title", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj tytuł artykułu"
              className="mt-1"
            />
          </label>
          <label className="block">
            <Input
             {...register("description", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj opis do artykułu"
              className="mt-1"
            />
          </label>
          <label className="block"> Dodaj długi opis pod tytułem artykułu
            <EditorProvider>
      <Editor value={longDescription} onChange={(e) => setLongDescription(e.target.value)}>
       <Toolbar>
  <BtnUndo />
  <BtnRedo />

  <Separator />

  <BtnBold />
  <BtnItalic />
  <BtnUnderline />

  <Separator />

  <BtnBulletList />
  <BtnNumberedList />

  <Separator />

  <BtnLink />

  <Separator />

  <BtnClearFormatting />

  <Separator />

  <BtnStyles />

  <Separator />

  <button
    type="button"
    onClick={() =>
      fileInputRef.current?.click()
    }
    style={{
      padding: "4px 10px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      cursor: "pointer",
    }}
  >
    📷 Zdjęcie
  </button>
</Toolbar>
      </Editor>
    </EditorProvider>
    <input
  ref={fileInputRef}
  hidden
  type="file"
  accept="image/*"
  onChange={(e) => handleEditorImageUpload(e, setLongDescription)}
/>
          </label>
          <label className="block">
            <select name="kategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz kategorie</option>
            {categories
            .map((category, index) => {
              return <option id={category.id} key={category.id} value={category.name}>{category.name}</option>
            })}
            </select>
          </label>
          {parseInt(categoryid) === 1 &&
          <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => parseInt(subcategory.id) === 1 || parseInt(subcategory.id) === 2 || parseInt(subcategory.id) === 3 || parseInt(subcategory.id) === 10 || parseInt(subcategory.id) === 17  ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
           {parseInt(categoryid) === 3 &&
          <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => parseInt(subcategory.id) === 1 || parseInt(subcategory.id) === 2 || parseInt(subcategory.id) === 3 || parseInt(subcategory.id) === 9 || parseInt(subcategory.id) === 10 ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}  
          {parseInt(categoryid) === 5 && <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
             .filter((subcategory) => parseInt(subcategory.id) === 1 || parseInt(subcategory.id) === 2 || parseInt(subcategory.id) === 3 || parseInt(subcategory.id) === 4 ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 6 && <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => parseInt(subcategory.id) === 5) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
          <p>Prosze pamiętać żeby wybrać odpowiednią sekcje na której pojawi sie dany artykuł w stronie głównej,jeśli nie chcecie żeby artykuł był widoczny na stronie głównej prosze wybrać opcje "Brak sekcji"</p>
          {parseInt(categoryid) === 5 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 1 || section.id === 9 || section.id === 2 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 1 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 3 || section.id === 1 || section.id === 9 || section.id === 8 || section.id === 4 || section.id === 5 || section.id === 6 || section.id === 7 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 3 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 3 || section.id === 9 || section.id === 1 || section.id === 5 || section.id === 6 || section.id === 7 || section.id === 4 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 8 && <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => subcategory.id >= 11 && subcategory.id <= 16 ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 9 && <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => subcategory.id >= 18 && subcategory.id <= 21 ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
           {parseInt(categoryid) === 10 && <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => subcategory.id >= 22 && subcategory.id <= 26 ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 11 && <label className="block">
            <select name="podkategorie" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz podkategorie</option>
            {subcategories
            .filter((subcategory) => subcategory.id >= 27 && subcategory.id <= 30 ) 
            .map((subcategory, index) => {
              return <option id={subcategory.id} key={subcategory.id} value={subcategory.title}>{subcategory.title}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 8 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 3 || section.id === 9 || section.id === 1 || section.id === 5 || section.id === 6 || section.id === 7 || section.id === 4 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 9 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 3 || section.id === 9 || section.id === 1 || section.id === 5 || section.id === 6 || section.id === 7 || section.id === 4 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 10 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 3 || section.id === 9 || section.id === 1 || section.id === 5 || section.id === 6 || section.id === 7 || section.id === 4 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
          {parseInt(categoryid) === 11 && <label className="block">
            <select name="sekcje" onChange={onChange} style={{borderRadius:"0px"}}>
            <option>Wybierz sekcje</option>
            {sections
            .filter((section) => section.id === 3 || section.id === 9 || section.id === 1 || section.id === 5 || section.id === 6 || section.id === 7 || section.id === 4 )
            .map((section, index) => {
              return <option id={section.id} key={section.id} value={section.sectionName}>{section.sectionName}</option>
            })}
            </select>
          </label>}
           <label className="block">
            <select onChange={onChange} name="type" style={{borderRadius:"0px"}}>
            <option value="">Wybierz rodzaj pliku</option>
            <option value="image">Zdjęcie</option>
            <option value="wideo">Wideo</option>
            </select>
          </label>
          <label className="block">
            <select onChange={onChange} name="status" style={{borderRadius:"0px"}}>
            <option value="">Wybierz opcję</option>
            <option value={0}>Ukryj</option>
            <option value={1}>Pokaż</option>
            </select>
          </label>
          { type == "wideo" && 
          <label className="block">Dodaj film
            <Input {...register("video", {
            })} type="file" max-size="200000" className="mt-1" />
          </label>}
          <label className="block">
            <select onChange={onChange} name="sponsor" style={{borderRadius:"0px"}}>
            <option value={2}>Wybierz rodzaj artykułu</option>
            <option value={0}>Artykuł zwykły</option>
            <option value={1}>Artykuł sponsorowany</option>
            </select>
          </label>
          <label className="block">Dodaj zdjęcie
            <Input {...register("image", {
            })} type="file" max-size="200000" className="mt-1" />
          </label>
          <label>Dodaj drugi opis pod zdjęciem artykułu</label>
          <label className="block">
            <EditorProvider>
      <Editor value={secondDescription} onChange={(e) => setSecondDescription(e.target.value)}>
       <Toolbar>
  <BtnUndo />
  <BtnRedo />

  <Separator />

  <BtnBold />
  <BtnItalic />
  <BtnUnderline />

  <Separator />

  <BtnBulletList />
  <BtnNumberedList />

  <Separator />

  <BtnLink />

  <Separator />

  <BtnClearFormatting />

  <Separator />

  <BtnStyles />

  <Separator />

  <button
    type="button"
    onClick={() =>
      fileInputRef.current?.click()
    }
    style={{
      padding: "4px 10px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      cursor: "pointer",
    }}
  >
    📷 Zdjęcie
  </button>
</Toolbar>
      </Editor>
    </EditorProvider>
    <input
  ref={fileInputRef}
  hidden
  type="file"
  accept="image/*"
  onChange={(e) => handleEditorImageUpload(e, setSecondDescription)}
/>
          </label>
          <ol style={{listStyleType:"initial"}}>Instrukcja jak dodać zdjęcia do galerii:
            <li>Klikamy "Wybierz pliki"</li>
            <li>Szukam naszej lokalizacji gdzie są zdjęcia, trzymamy przycisk ctrl i klikamy zdjęcia które nas interesują</li>
            <li>i pod spodem pojawią sie zdjęcia jakie wybraliśmy</li>
          </ol>
<label className="block">
  Dodaj galerię zdjęć

  <Input
    type="file"
    accept="image/*"
    multiple
    className="mt-1"
    onChange={(e) => {
      setGalleryImages(Array.from(e.target.files || []));
    }}
  />

  {galleryImages.length > 0 && (
    <div className="mt-3">
      <p className="mb-3 text-sm">
        Wybrano zdjęć: {galleryImages.length}
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {galleryImages.map((file, index) => (
          <div
            key={`${file.name}-${file.lastModified}-${index}`}
            className="relative overflow-hidden rounded-lg border"
          >
            <img
              src={URL.createObjectURL(file)}
              alt={`Podgląd zdjęcia ${index + 1}`}
              className="w-full h-28 object-cover"
            />

            <button
              type="button"
              onClick={() => {
                setGalleryImages((prev) =>
                  prev.filter((_, i) => i !== index)
                );
              }}
              className="absolute top-1 right-1 rounded-full bg-black/70 text-white w-7 h-7 flex items-center justify-center"
              aria-label={`Usuń zdjęcie ${index + 1}`}
              title="Usuń zdjęcie"
            >
              ×
            </button>

            <p className="px-2 py-1 text-xs truncate">
              {file.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  )}
</label>
          <Datetime value={date} className="form-control" locale="pl"  onChange={onChangeDate} />
        </form>
        <button onClick={resetDate} style={{paddingBottom:"20px"}}>Resetuj datę</button>
        <p>Chwilowo prosze usuwać lub zamieniać wszystkie pojedyncze apostrofy na podwójne w tekście artykułu</p>
        <ButtonPrimary onClick={addArticles}>Dodaj</ButtonPrimary>
        {loading == true && 
        <div style={{marginTop:'40px'}}>
          <p style={{marginBottom:'20px'}}>Uwaga dodawanie artykułu może chwile potrwać zależności od wielkości wysłanego zdjęcia.</p>
          <ClipLoader color="black" size={50} aria-label="Loading Spinner" data-testid="loader"/>
          </div>}
      </div>
    </Layout>
  );
};

export default PageAddArticles;